import {ActionTree} from "vuex";
import Vue from "vue";
import router from "../router";
import {errorHandler, getLoginReferrer} from "../library/utils/weaver";

const actions: ActionTree<RootState, RootState> = {
    logout()
    {
        return Vue.axios.post('/logout').then((response) =>
        {
            if (response.data.status === 'OK')
            {
                let loginReferrer = getLoginReferrer(router.currentRoute);
                let resolved      = router.resolve(loginReferrer);

                // push only if full path are different
                if (resolved.resolved.fullPath !== router.currentRoute.fullPath)
                {
                    // reload the page to reset all stuff (vuex, xhr manager...)
                    window.location.pathname = resolved.resolved.fullPath;
                }
                else
                {
                    window.location.reload();
                }
            }
            else
            {
                throw new Error(response.data);
            }
        }).catch(errorHandler);
    },
    setLayoutData({commit, dispatch}, data)
    {
        commit('setLayoutData', data);
    },
    getLayoutData({dispatch})
    {
        return Vue.axios.get('/application/index/get-layout-data').then((response) =>
        {
            try
            {
                let data = response.data.data;
                dispatch('setLayoutData', data);
                if (process.env.NODE_ENV === 'production')
                {
                    //TODO: configure Sentry
                }

                return data;
            }
            catch (err)
            {
                throw new Error('NOT_LOGGED_IN');
            }
        });
    },
    hideApp({commit, state}, hide)
    {
        if (state.hideApp !== hide)
        {
            commit('hideApp', hide);
        }
    },
};

export default actions;
